/** @format */

import template from './gb-countdown-widget.html';
import './gb-countdown-widget.scss';

import * as moment from 'moment-timezone';

import { floor } from 'lodash';

export const GbCountdownWidgetComponent = {
    require: {
        gbApp: '^^',
        gbWidget: '^^',
    },
    template,
    controller: class GbCountdownWidgetComponent {
        constructor($interval) {
            'ngInject';
            this.$interval = $interval;
        }

        $onInit() {
            this.setCountdownValues();
            this.countdownTimerSetter = this.$interval(() => this.setCountdownValues(), 1000);
        }

        $onDestroy() {
            this.$interval.cancel(this.countdownTimerSetter);
        }

        setCountdownValues() {
            const endDateTime = moment(this.getWidget().end).format('YYYY-MM-DDTHH:mm:ss');

            const timezone = this.getWidget().timezone;

            this.end = moment.tz(endDateTime, timezone).format('YYYY-MM-DDTHH:mm:ssZ');
            this.now = new Date();

            this.timeTo = Date.parse(this.end) - Date.parse(this.now);

            this.seconds = floor((this.timeTo % (1000 * 60)) / 1000);
            this.minutes = floor((this.timeTo % (1000 * 60 * 60)) / (1000 * 60));
            this.hours = floor((this.timeTo % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.days = floor(this.timeTo / (1000 * 60 * 60 * 24));

            this.seconds = this.setPrefix(this.seconds);
            this.minutes = this.setPrefix(this.minutes);
            this.hours = this.setPrefix(this.hours);
            this.days = this.setPrefix(this.days);
        }

        hasCountdownElapsed() {
            return this.timeTo <= 0;
        }

        getElapsedClass() {
            // Minor simplification of logic.
            if (this.hasCountdownElapsed() && this.getTimeoutText()) {
                return 'elapsed';
            }
            return '';
        }

        setPrefix(value) {
            if (value <= 0) {
                return '0';
            }

            if (value < 10) {
                return `0${value}`;
            }

            return value;
        }

        getWidget() {
            return this.gbWidget.widget;
        }

        /**
         * Determines if a time unit should be displayed based on the total remaining time.
         * @param {string} timeUnit - 'days', 'hours', 'minutes', or 'seconds'.
         * @returns {boolean} True if the unit should be visible.
         */
        shouldShowDateTimeUnit(timeUnit) {
            // Using constants (or just the numbers) for clarity in ms.
            const MS_IN_DAY = 86400000;
            const MS_IN_HOUR = 3600000;
            const MS_IN_MINUTE = 60000;

            // Check if the total remaining time exceeds the threshold for that unit.
            switch (timeUnit) {
                case 'days':
                    return this.timeTo > MS_IN_DAY;
                case 'hours':
                    return this.timeTo > MS_IN_HOUR;
                case 'minutes':
                    return this.timeTo > MS_IN_MINUTE;
                case 'seconds':
                    return this.timeTo > 0;
                default:
                    return false;
            }
        }

        getTimeoutText() {
            const isEditMode = this.gbApp && this.gbApp.isEditMode();
            const hasElapsed = this.hasCountdownElapsed();
            const customText = this.getWidget().timeout_text;

            if (isEditMode && hasElapsed && !customText) {
                return 'Countdown finished';
            }

            return customText;
        }
    },
};
